import { enContentType, IContent } from '@/interfaces/lesson';

import Audio from './Audio';
import Embed from './Embed';
import Text from './Test';
import Video from './Video';
import Videozz from './Videozz';

const FallbackComponent = () => <></>;

const LessonType = (props: IContent) => {
  const mapper: Record<string, any> = {
    [enContentType.YOUTUBE_VIMEO]: Video,
    [enContentType.EMBED]: Embed,
    [enContentType.TEXT]: Embed,
    [enContentType.AUDIO]: Audio,
    [enContentType.VIDEOZZ]: Videozz,
    [enContentType.FABRICA_PROVAS]: Text,
    [enContentType.SAFE_VIDEO]: Video
  };

  const ComponnetMapper = mapper[String(props.type.id)] ?? FallbackComponent;

  return <ComponnetMapper {...props} />;
};

export default LessonType;
